export const OPEN_NOTIFICATION_DIALOG = "OPEN_NOTIFICATION_DIALOG";

export const CLOSE_NOTIFICATION_DIALOG = "CLOSE_NOTIFICATION_DIALOG";

export const SEND_ALL_NOTIFICATION = "SEND_ALL_NOTIFICATION";

export const SEND_PERSONAL_NOTIFICATION = "SEND_PERSONAL_NOTIFICATION";
